<template>
  <navbar />
  <div>
    <div>
      <router-view></router-view>
    </div>
  </div>
  <FooterAll/>
</template>

<script>
import FooterAll from './components/footer-all.vue';
import navbar from './components/navbar.vue';

export default {
  name: 'App',
  components: {
    navbar, 
    FooterAll
  }
}
</script>


<style>

</style>